import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export function useLanguageToggle() {
  const { i18n } = useTranslation();

  const toggleLanguage = useCallback(() => {
    void i18n.changeLanguage(i18n.language === "en" ? "hr" : "en");
  }, [i18n]);

  const languageButtonLabel = i18n.language === "en" ? "Hrvatski" : "English";

  return {
    languageCode: i18n.language,
    languageButtonLabel,
    toggleLanguage,
  };
}
